import React from "react";
import Seo from "../components/Seo";
import { Hero } from "../components/Section";
import ContactForm from "../components/ContactForm";
import { Mail, MapPin } from "lucide-react";
import { EditorialIcon } from "../components/EditorialVisuals";

const LEAD = "Syni.ai is headquartered in Nairobi. Write to us about Aky, Lead.ai, research collaboration or anything else.";

export default function Contact() {
  return (
    <>
      <Seo title="Contact — Syni.ai" description={LEAD} path="/contact" />
      <Hero title="Contact" lead={LEAD} testId="contact-hero">
        <div className="contact-meta" data-testid="contact-meta">
          <span data-testid="contact-email-detail">
            <EditorialIcon icon={Mail} testId="contact-email-icon" />
            <span className="contact-meta-text">Email:{" "}
            <a href="mailto:info@syni.ai" className="link-accent" data-testid="contact-email-link">
              info@syni.ai
            </a>
            </span>
          </span>
          <span data-testid="contact-address">
            <EditorialIcon icon={MapPin} testId="contact-address-icon" />
            <span className="contact-meta-text">Address: Riverside Square, Off Riverside Drive, Nairobi</span>
          </span>
        </div>
      </Hero>

      <section className="section" style={{ paddingTop: 0 }} data-testid="contact-form-section">
        <div className="container-syni">
          <div className="form-wrap">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
